import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { ArchivioAllertaMassimaService } from './archivio-allerta-massima.service';
import { MultiButtonRendererComponent } from 'app/generic/multi-button-renderer/multi-button-renderer.component';

@Component({
  selector: 'archivio-allerta-massima',
  templateUrl: './archivio-allerta-massima.component.html',
  styleUrls: ['./archivio-allerta-massima.component.scss'],
  providers: [ArchivioAllertaMassimaService]
})
export class ArchivioAllertaMassimaComponent implements OnInit {

  modelList: any[] = [];
  articolo: any = {};
  promiseBusy: Promise<any[]>;
  refreshData: boolean = false;
  PDFbyte: any;
  promisePDF: Promise<any>;
  showYearSelect: boolean = false;
  yearSelect: any[] = [];

  pagInizio: number = 0;
  pagFine: number = 100;
  numRisultati: number;
  showLoadMore: boolean = false;
  page: number = 1;
  promiseAppendDataTable: Promise<any>;

  actualPage: number = 1;
  gridOptions: any;
  data = [];
  @ViewChild('theModalDettaglio') theModalDettaglio: ElementRef;
  @ViewChild('errorModal') errorModal!: TemplateRef<any>;
  modelPdf: SafeResourceUrl;
  numeroForTitle: any;
  private pdfObjectUrl: string | null = null;

  // datepicker
  annoSelezione = new Date().getFullYear();
  today: NgbDateStruct;
  dataDa: any;
  dataA: any;
  openFilters = false;
  isErroreDataDa: boolean = false;
  isErroreDataA: boolean = false;

  customLocaleText = {
    noRowsToShow: 'Nessun dato disponibile',
    loadingOoo: 'Caricamento in corso...',
    page: 'Pagina',
    of: 'di',
    more: 'Altro',
    to: 'a'
  };

  filterParamsData = {
    comparator: (filterLocalDateAtMidnight: Date, cellValue: any) => {
      if (!cellValue) return -1; // 🔹 Se la cella è vuota, ignora

      let cellDate: Date;

      // 🔹 Se `cellValue` è già un oggetto Date, usalo direttamente
      if (cellValue instanceof Date) {
        cellDate = cellValue;
      }
      // 🔹 Se è una stringa, convertila in un oggetto Date
      else if (typeof cellValue === "string") {
        const match = cellValue.match(/(\d{2})\/(\d{2})\/(\d{4})$/); // Cerca "DD/MM/YYYY"
        if (!match) return -1; // Se non è nel formato corretto, ignoralo

        const [, day, month, year] = match;
        cellDate = new Date(Number(year), Number(month) - 1, Number(day));
      }
      // 🔹 Se è di un tipo sconosciuto, ignora
      else {
        return -1;
      }

      // 🔹 Confronta le date senza orario
      const filterTime = filterLocalDateAtMidnight.setHours(0, 0, 0, 0);
      const cellTime = cellDate.setHours(0, 0, 0, 0);

      return cellTime === filterTime ? 0 : (cellTime < filterTime ? -1 : 1);
    },
    maxValidYear: new Date().getFullYear(),
  };


  constructor(
    public restService: ArchivioAllertaMassimaService,
    private modalService: NgbModal,
    private _sanitizer: DomSanitizer,
    private newModal: NewModalService,
  ) {
    // Inizializza today per il datepicker
    const now = new Date();
    this.today = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate()
    };
  }

  ngOnInit() {
    // document.getElementById('nb-global-spinner').style.display = 'block';
    this.createBollettiniList((new Date()).getFullYear());
    this.createYearSelect();
    this.setupAgSettings()
  }

  ngAfterViewInit() {

  }

  switchOpen() {
    this.openFilters = !this.openFilters
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  setupAgSettings() {
    let ref = this;

    ref.gridOptions = {
      animateRows: true,
      pagination: true,
      paginationPageSize: 10,
      // localeText: AG_GRID_LOCALE_IT, //impostazioni lingua
      enableCellTextSelection: true, //per poter copiare il valore dal browser
      rowHeight: 50,
      defaultColDef: { //parametri di default per ogni colonna (gli stessi possono essere utilizzati singolarmente nei columnDefs)
        editable: false,
        filter: true, //viene visualizzata l'icona per inserire i filtri sulla colonna
        sortable: true, // permette l'ordinamento delle colonne
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellClass: 'fontClamp',
        headerClass: 'header-center',
        suppressMenu: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          // filterOptions: ['contains'], // per impostare le optioni di filtro di filtro
          suppressAndOrCondition: true, // per non far visualizzare le condizioni AND e OR
          // buttons: ["apply", "reset"],
        },
      },
      rowStyle: {
        background: '#fff',
        color: '#000'
      },
      columnDefs: [
        {
          headerName: "Numero Avviso", //nome della colonna
          field: "numeroAvviso", //hiave di riferimento all'oggetto da far visualizzare
          filter: "agTextColumnFilter",  // Tipo di filtro
          floatingFilter: true,           // Abilita il Floating Filter
          valueFormatter: (params: any) => { // per customizzare il valore della cella
            return params.value ? params.value : "-";
          },
        },
        {
          headerName: "Data Emissione",
          field: "dataEmissione",
          filter: "agDateColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => {
            return params.value ? this.formattaDataInStringa(params.value) : "-";
          },
        },
        {
          headerName: "Data Inizio Validità",
          field: "dataDa",
          filter: "agDateColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => {
            return params.value ? this.formattaDataInStringa(params.value) : "-";
          },
        },
        {
          headerName: "Data Fine Validità",
          field: "dataA",
          filter: "agDateColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => {
            return params.value ? this.formattaDataInStringa(params.value) : "-";
          },
        },
        {
          headerName: "Azioni",
          field: "buttons",
          cellRenderer: MultiButtonRendererComponent,
          filter: false,
          sortable: false,
          cellRendererParams: {
            value: [
              {
                label: 'Vedi dettaglio',
                class: 'clamp-icon icon now-ui-icons ui-1_zoom-bold btn btn-primary pointer',
                action: (row: any) => {

                  this.onUserRowSelect(row);
                }
              },
              {
                label: 'Scarica file',
                class: 'clamp-icon icon now-ui-icons arrows-1_cloud-download-93 btn btn-primary pointer',
                action: (row: any) => {

                  this.onDownloadSelect(row)
                }
              },
              /* {
                  label: "Effettua prenotazione",
                  class: 'fas fa-plus btn-first minPadding pointer',
                  action: (row: any) => {
                    ref.travelDetail = row;
                    ref.aggiungiViaggio(ref.travelDetail);
                  }
              } */
            ]
          }
        }
      ]
    }
  }

  onPaginationChanged(event: any) {
    let ref = this;

    if (event.newPage) {
      ref.actualPage = event.api.paginationGetCurrentPage() + 1;
    }
  };

  createBollettiniList(anno: number): void {
    this.data = [];
    this.restService.selectAllByAnno(anno)
      .then(res => {
        if (res != null) {
          res.forEach(element => {
            try {
              element.numeroAvviso = `${element.numeroAvviso}/${element.anno}`;

              // Converti le date in formato stringa "yyyy-MM-dd"
              element.dataEmissione = this.convertiStringaInData(element.dataEmissione);
              element.dataDa = this.convertiStringaInData(element.dataDa);
              element.dataA = this.convertiStringaInData(element.dataA);
            } catch (error) {
              console.error('Errore nella conversione degli elementi:', error);
            }
          });

          this.data = res;
          this.modelList = res;
          this.refreshData = true;
          this.numRisultati = res.length;
        }
      })
      .catch(error => {
        this.data = [];
        this.modelList = [];
        this.refreshData = true;
        this.numRisultati = 0;
        this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");

      });
  }


  findBollettiniPeriodo() {
    // Reset degli errori
    this.isErroreDataDa = false;
    this.isErroreDataA = false;

    if (this.dataDa && this.dataA) {
      // Converti le date NgbDateStruct in millisecondi
      const dataDaMillis = this.toMillis(this.dataDa);
      const dataAMillis = this.toMillis(this.dataA);
      
      if (dataDaMillis > dataAMillis) {
        this.newModal.open(
          "Attenzione",
          "La data di inizio non può essere maggiore di quella di fine",
          "bg-danger"
        );
        this.isErroreDataDa = true;
        this.isErroreDataA = true;
        return;
      } else {
        // Passa le date in millisecondi al servizio
        this.restService.selectAllByAnnoPeriodo(this.annoSelezione, dataDaMillis, dataAMillis).then(res => {
          // Log per debug - rimuovere in produzione
          console.log('Risposta servizio selectAllByAnnoPeriodo:', res);
          
          if (res != null && Array.isArray(res)) {
            res.forEach(element => {
              try {
                // Log per debug - rimuovere in produzione
                console.log('Elemento ricevuto:', element);
                
                // Verifica che i campi esistano prima di usarli
                if (element.numeroAvviso != null && element.anno != null) {
                  element.numeroAvviso = `${element.numeroAvviso}/${element.anno}`;
                } else if (element.numeroAvviso != null) {
                  // Se manca solo l'anno, prova a usare solo numeroAvviso
                  console.warn('Campo anno mancante per elemento:', element);
                  element.numeroAvviso = `${element.numeroAvviso}`;
                } else {
                  console.warn('Elemento con dati mancanti (numeroAvviso o anno):', element);
                }

                // Converti le date in formato Date object
                element.dataEmissione = this.convertiStringaInData(element.dataEmissione);
                element.dataDa = this.convertiStringaInData(element.dataDa);
                element.dataA = this.convertiStringaInData(element.dataA);
              } catch (error) {
                console.error('Errore nella conversione degli elementi:', error, element);
              }
            });

            this.data = res;
            this.modelList = res;
            this.refreshData = true;
            this.numRisultati = res.length;
          } else {
            this.data = [];
            this.modelList = [];
            this.refreshData = true;
            this.numRisultati = 0;
          }
        }).catch(error => {
          console.error('Errore nella chiamata al servizio:', error);
          this.data = [];
          this.modelList = [];
          this.refreshData = true;
          this.numRisultati = 0;
          this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
        });
      }
    } else {
      this.newModal.open(
        "Attenzione",
        "Seleziona un intervallo di date",
        "bg-danger"
      );
      if (!this.dataDa) this.isErroreDataDa = true;
      if (!this.dataA) this.isErroreDataA = true;
    }
  }

  toMillis(date: NgbDateStruct): number {
    return new Date(date.year, date.month - 1, date.day).getTime();
  }

  resetBollettini() {
    this.dataDa = null
    this.dataA = null
    this.createBollettiniList(this.annoSelezione)
  }

  convertiStringaInData(dataStringa: string): Date | null {
    if (!dataStringa) return null;

    // 🔹 Usa una regex per estrarre la parte della data (ignora l'orario)
    const match = dataStringa.match(/(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      return new Date(Number(year), Number(month) - 1, Number(day));
      // 🔹 Il mese in JavaScript parte da 0, quindi sottraiamo 1
    }

    return null;
  }

  formattaDataInStringa(data: Date | null): string {
    if (!data) return "-"; // Se la data è nulla, restituisci un valore predefinito

    const giorno = data.getDate().toString().padStart(2, "0"); // Assicura due cifre
    const mese = (data.getMonth() + 1).toString().padStart(2, "0"); // Mese da 0 a 11, quindi +1
    const anno = data.getFullYear();

    return `${giorno}/${mese}/${anno}`;
  }

  formattaDataPerNomeFile(data: Date | null): string {
    if (!data) return ""; // Se la data è nulla, restituisci stringa vuota

    const giorno = data.getDate().toString().padStart(2, "0");
    const mese = (data.getMonth() + 1).toString().padStart(2, "0");
    const anno = data.getFullYear();
    const ore = data.getHours().toString().padStart(2, "0");
    const minuti = data.getMinutes().toString().padStart(2, "0");

    return `${giorno}_${mese}_${anno} - ${ore}_${minuti}`;
  }

  formattaDataPerNomeFileAvviso(data: Date | null): string {
    if (!data) return ""; // Se la data è nulla, restituisci stringa vuota

    const giorno = data.getDate().toString().padStart(2, "0");
    const mese = (data.getMonth() + 1).toString().padStart(2, "0");
    const anno = data.getFullYear();
    const ore = data.getHours().toString().padStart(2, "0");
    const minuti = data.getMinutes().toString().padStart(2, "0");

    // Formato per avviso allerta: HH_MM - DD_MM_YYYY
    return `${ore}_${minuti} - ${giorno}_${mese}_${anno}`;
  }

  parseDateStringWithTime(dateString: string): Date | null {
    if (!dateString) return null;

    // Dividiamo la parte della data e dell'orario
    const parts = dateString.split(" - ");
    if (parts.length < 2) return null;

    let day: number, month: number, year: number;
    let hours: number = 0;
    let minutes: number = 0;

    // Controlla se il formato è "HH:MM - DD/MM/YYYY" (avviso allerta) o "DD/MM/YYYY - HH:MM" (bollettino)
    const firstPart = parts[0].trim();
    const secondPart = parts[1].trim();

    // Se la prima parte contiene ":" è l'orario (formato avviso allerta: "HH:MM - DD/MM/YYYY")
    if (firstPart.includes(":")) {
      // Formato: "11:44 - 13/06/2025"
      const [h, m] = firstPart.split(":").map(Number);
      hours = h || 0;
      minutes = m || 0;
      
      // La seconda parte è la data
      const dateParts = secondPart.split("/");
      if (dateParts.length !== 3) return null;
      day = Number(dateParts[0]);
      month = Number(dateParts[1]);
      year = Number(dateParts[2]);
    } else if (secondPart.includes(":")) {
      // Formato: "DD/MM/YYYY - HH:MM" (bollettino meteo)
      const dateParts = firstPart.split("/");
      if (dateParts.length !== 3) return null;
      day = Number(dateParts[0]);
      month = Number(dateParts[1]);
      year = Number(dateParts[2]);
      
      const [h, m] = secondPart.split(":").map(Number);
      hours = h || 0;
      minutes = m || 0;
    } else {
      // Solo data senza orario
      const dateParts = firstPart.split("/");
      if (dateParts.length !== 3) return null;
      day = Number(dateParts[0]);
      month = Number(dateParts[1]);
      year = Number(dateParts[2]);
    }

    // Attenzione: il mese in JavaScript è 0-based, quindi sottraiamo 1
    return new Date(year, month - 1, day, hours, minutes);
  }


  // visualizzaAltriBollettini() {

  //   var ref = this;
  //   this.pagInizio += 101;
  //   var nowPage = this.source.getPaging().page;

  //   this.restService.selectAllDaA(this.pagInizio, this.pagFine).then(
  //     res => {
  //       if(res.length < 100){
  //         ref.showLoadMore = false;
  //       }

  //       res.forEach(element => {
  //         ref.promiseAppendDataTable = ref.source.append(element);
  //         ref.promiseAppendDataTable.then(
  //           ritorno => {
  //             ref.source.setPaging(nowPage, 10, true);
  //           }
  //         );
  //       }); 
  //     }
  //   )

  // }

  onSelectChange(event: any) {
    this.createBollettiniList(event.currentTarget.value);
  }

  createYearSelect() {

    var yearStart = 2018;
    var nowYear = (new Date()).getFullYear();

    if ((nowYear - yearStart) > 0) {

      this.yearSelect.push(nowYear);
      while (nowYear > yearStart) {
        nowYear -= 1;
        this.yearSelect.push(nowYear);
      }
      this.showYearSelect = true;
    }

  }

  onUserRowSelect(event) {

    // document.getElementById('nb-global-spinner').style.display = 'block';

    var ref = this;
    this.restService.findByIdBollettino(event.idBollettino).then(
      data => {
        if (data && data != null) {
          this.restService.getPDFbyte(event.urlPdf).then(
            (res) => {
              if (res && res != null) {
                if (res && typeof res === 'object' && Object.keys(res).length === 0) {
                  this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
                } else {
                  // Crea un Blob URL per visualizzare il PDF nell'iframe (evita il download automatico)
                  const { url, safeUrl } = this.createPdfObjectUrl(res.file);
                  this.pdfObjectUrl = url;
                  this.modelPdf = safeUrl;
                  this.openModal(data.dataEmissione, this.modelPdf);
                }
              } else {
                this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
              }
            }
          ).catch((err) => {
            this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
          });
        } else {
          this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
        }
        //ref.openModal(data.numeroAvviso + "/" + data.anno, data);
      }
    );


  }

  onDownloadSelect(event) {
    // document.getElementById('nb-global-spinner').style.display = 'block';

    let ref = this;

    this.restService.findByIdBollettino(event.idBollettino).then(
      res => {
        //ref.openModal(data.dataEmissione, data);
        if (res && res != null) {
          // Usa sempre res.dataEmissione se è una stringa, perché contiene la data completa con orario
          // event.dataEmissione potrebbe essere un Date senza orario (convertito da convertiStringaInData)
          let dataEmissione: Date | null = null;

          if (res.dataEmissione) {
            if (typeof res.dataEmissione === 'string') {
              // Se è una stringa, parsala (dovrebbe contenere "DD/MM/YYYY - HH:MM" o solo "DD/MM/YYYY")
              console.log("res.dataEmissione (stringa):", res.dataEmissione);
              dataEmissione = this.parseDateStringWithTime(res.dataEmissione);
              // Se il parsing non ha funzionato, prova a convertire solo la data
              if (!dataEmissione) {
                dataEmissione = this.convertiStringaInData(res.dataEmissione);
              }
            } else if (res.dataEmissione instanceof Date) {
              dataEmissione = res.dataEmissione;
            }
          }

          // Se ancora non abbiamo la data, prova con event.dataEmissione
          if (!dataEmissione && event.dataEmissione) {
            if (event.dataEmissione instanceof Date) {
              dataEmissione = event.dataEmissione;
            } else if (typeof event.dataEmissione === 'string') {
              dataEmissione = this.parseDateStringWithTime(event.dataEmissione);
              if (!dataEmissione) {
                dataEmissione = this.convertiStringaInData(event.dataEmissione);
              }
            }
          }

          console.log("dataEmissione finale:", dataEmissione);
          const dataFormattata = this.formattaDataPerNomeFileAvviso(dataEmissione);
          console.log("dataFormattata:", dataFormattata);

          this.restService.getPDFbyte(res.urlPdf).then(
            res2 => {
              if (res2 && res2 != null) {
                if (res && typeof res === 'object' && Object.keys(res).length === 0) {
                  this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
                } else {
                  console.log("Risposta API:", res2);
                  console.log("Tipo di risposta:", typeof res2.file);

                  //this.PDFbyte = "data:application/pdf;base64,"+res[0].base64;
                  var forExecElement = document.createElement("a");
                  forExecElement.id = "download_bollettino";
                  forExecElement.href = "data:application/pdf;base64," + res2.file;
                  forExecElement.download = "avviso_allerta_(" + dataFormattata + ").pdf";

                  document.body.appendChild(forExecElement);

                  document.getElementById('download_bollettino').click();

                  document.body.removeChild(forExecElement);

                  // document.getElementById('nb-global-spinner').style.display = 'none';
                  // document.getElementsByClassName('scrollable-container')[0].scrollTop = 0;

                }
              }
            }
          ).catch(error => {
            this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
          });

        } else {
          this.newModal.open("Errore", "Non è stato possibile recuperare le informazioni richieste. Riprovare più tardi.", "bg-danger");
        }

      }
    );
  }

  openModal(numeroBollettino: any, model: any) {
    this.numeroForTitle = numeroBollettino
    this.modelPdf = model;



    setTimeout(() => {
      this.modalService.open(this.theModalDettaglio, {
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
      });
    }, 200);
  }

  closeSingleModal(modal) {
    modal.close('close');
    // Libera l'Object URL del PDF
    if (this.pdfObjectUrl) {
      URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = null;
    }
    this.modelPdf = null;
  }

  openErrorModal(content: TemplateRef<any>) {
    this.modalService.open(content, { backdrop: 'static', keyboard: false });
  }

  applyDateFilter() {
    if (!this.gridOptions || !this.gridOptions.api) {
      return;
    }

    const dataDa = this.dataDa ? this.formatDate(this.dataDa) : null;
    const dataA = this.dataA ? this.formatDate(this.dataA) : null;

    this.gridOptions.api.setFilterModel({
      dataEmissione: {
        filterType: 'date',
        type: 'inRange',
        dateFrom: dataDa,
        dateTo: dataA
      }
    });

    this.gridOptions.api.onFilterChanged();
  }

  formatDate(ngbDate: any): string {
    if (!ngbDate) return null;
    const day = String(ngbDate.day).padStart(2, '0');
    const month = String(ngbDate.month).padStart(2, '0');
    const year = ngbDate.year;
    return `${year}-${month}-${day}`;
  }

  private createPdfObjectUrl(base64: string): { url: string; safeUrl: SafeResourceUrl } {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
    return { url, safeUrl };
  }

  // onSearch(query: string = '') {
  //   this.source.setFilter([
  //     // fields we want to include in the search
  //     {
  //       field: 'numeroAvviso',
  //       search: query
  //     },
  //   ], false);
  //   // second parameter specifying whether to perform 'AND' or 'OR' search 
  //   // (meaning all columns should contain search query or at least one)
  //   // 'AND' by default, so changing to 'OR' by setting false here
  // }


}
